// extracted by mini-css-extract-plugin
export default {"card":"launcher-module__card--mIz8j","bubbleContainer":"launcher-module__bubbleContainer--OEWMi"};